import { Component, ViewEncapsulation } from '@angular/core';

/**
 * This is the Skeleton Component. It renders skeletons when a form is loading.
 **/
@Component({
    selector: 'ap-skeleton',
    templateUrl: './skeleton.component.html',
    encapsulation: ViewEncapsulation.Emulated
})
export class ApSkeletonComponent {}
